import { Path } from "./PagePath";

export const pageTitles = [
    { title: "ホーム", path: Path.root },
    { title: "お気に入り", path: Path.favoriteMemories },
    { title: "ログイン", path: Path.signin },
    { title: "新規登録", path: Path.signup },
    { title: "新規登録完了", path: Path.signupResult },
    { title: "利用規約", path: Path.terms },
    {
        title: "パスワード再設定メール送信",
        path: Path.passwordResetSendConfirmationCode,
    },
    {
        title: "パスワード再設定メール送信完了",
        path: Path.passwordResetSendConfirmationCodeCompleted,
    },
    { title: "パスワード再設定", path: Path.passwordResetNewPassword },
    {
        title: "パスワード再設定完了",
        path: Path.passwordResetNewPasswordCompleted,
    },
    { title: "やり取り相手一覧", path: Path.answerers },
    { title: "プロフィール", path: Path.profile },
    { title: "やり取り相手", path: Path.answerer },
    { title: "やり取り相手詳細", path: Path.answererDetail },
    {
        title: "やり取り相手詳細（送信頻度選択）",
        path: Path.answererDetailQmailSendFrequency,
    },
    { title: "記憶詳細", path: Path.memorydetail },
    { title: "利用案内確認", path: Path.useStartMailRemind },
    { title: "メールアドレス確認", path: Path.emailConfirm },
    { title: "アクティビティ詳細", path: Path.activityDetail },
    { title: "アクティビティ返信詳細", path: Path.activityReplyDetail },
    { title: "あなたのニックネーム", path: Path.receivernickname },
    { title: "メールアドレス確認", path: Path.senderEmailConfirm },
    { title: "確認メール送信完了", path: Path.sendEmailCompleted },
    { title: "季節のおたより一覧", path: Path.wellnessChecks },
    { title: "季節のおたより詳細", path: Path.wellnessCheckDetail },
    { title: "追加質問一覧", path: `${Path.questionList}/:answererId` },
    { title: "追加質問登録", path: `${Path.addQuestion}/:answererId` },
    { title: "追加質問詳細", path: `${Path.updateQuestion}/:answererId/:id` },
    {
        title: "送信済み質問詳細",
        path: `${Path.sentQuestionDetail}/:answererId/:id`,
    },
    { title: "ストーリー投稿", path: Path.postStory },
    { title: "エラー", path: Path.error },
    { title: "ページが見つかりません", path: Path.notFound },
];
